import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useLocation } from "react-router";
import { GetSelectedLanguage, GetSelectedLanguageSubdirectory } from '../../services/utilities';

const SignInButton = (props) => {
    const { instance, inProgress } = useMsal();
    const location = useLocation();
    
    const handleLogin = () => {
        if (inProgress !== InteractionStatus.None) {
            console.log('Login is already in progress. Please wait.');
            return;
        }
        var loginRequest = {
            ...loginRequest,
            redirectUri: window.location.origin + GetSelectedLanguageSubdirectory() + "/preferred-customer/auth", 
            state: location.pathname,
            extraQueryParameters: {
                lang: GetSelectedLanguage()
            }
        };
        instance.loginRedirect(loginRequest)
            .catch(e => {
                console.error('Error After Login Redirect', e);
            });
    }

    return (
        <button className={props.cssClasses} onClick={() => handleLogin()}>LOG IN</button>
    );
}

export default SignInButton;